import React from "react";
import JobSearch from "./JobSearch";
import JobCoverage from "./JobCoverage";
import useContactNumber from './useContactNumber';
import RequiredOptions from './RequiredOptions';
import PostcodeSearch from "./PostcodeSearch";
import useDebugInformation from "../../../../../../../hooks/useDebugInformation";
import AddressModal from "../../../../../../Shared/AddressesModal";

const name = "ProblemDetails"

type Props = {
  parent: string
}

const prefix = "PropertyAddress"

const ProblemDetails: React.FC<Props> = ({ parent }) => {
  useContactNumber();
  const inputRef = React.useRef<HTMLInputElement>(null);

  const debugName = `${parent}▷[${name}]`

  useDebugInformation(debugName, { parent })
  return <>
    <JobSearch parent={debugName} inputRef={inputRef} />
    <RequiredOptions parent={debugName} />
    <AddressModal prefix={prefix} />
    <PostcodeSearch inputRef={inputRef} />
    <JobCoverage parent={debugName} />
  </>;
};

ProblemDetails.displayName = name;


export default React.memo(ProblemDetails);
